module.exports = "/assets/c2a784b2f69ed14f7e3fe747dba9c414.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/ZG.png
// module id = 2063
// module chunks = 0